import { produce, type WritableDraft } from "immer";
import { create } from "zustand";
import type { DeepResearchReportMetadata } from "@/types/deep-research-reports";

export interface DeepResearchReportsState {
  byId: Record<string, DeepResearchReportMetadata>;
  updateOne: (reportId: string, payload: DeepResearchReportMetadata) => void;
}

export const useDeepResearchReportsStore = create<DeepResearchReportsState>(
  (set) => ({
    byId: {} as Record<string, DeepResearchReportMetadata>,

    updateOne: (
      reportId: string,
      payload: DeepResearchReportMetadata,
    ): void => {
      set(
        produce((draft: WritableDraft<DeepResearchReportsState>) => {
          draft.byId[reportId] = payload;
        }),
      );
    },
  }),
);
